export function ValidateId(country: string, type:number, id:string) {

  if (country === 'ES') {
    let v = id.replace(/-/g, '');
    let check;
    let isValid;
    switch (type) {
      case 8:
        isValid = /^[0-9]{8}[-]{0,1}[A-HJ-NP-TV-Z]$/.test(v);
        if (!isValid) return false;
        if (isValid) {
          check = parseInt(v.substr(0, 8), 10);
          check = 'TRWAGMYFPDXBNJZSQVHLCKE'[check % 23];
          return (check === v.substr(8, 1));
        }
        break;
      case 12:
        isValid = /^[XYZ][-]{0,1}[0-9]{7}[-]{0,1}[A-HJ-NP-TV-Z]$/.test(v);
        if (!isValid) return false;
        if (isValid) {
          const index = 'XYZ'.indexOf(v.charAt(0));
          v = `${index + v.substr(1)}`;
          check = parseInt(v.substr(0, 8), 10);
          check = 'TRWAGMYFPDXBNJZSQVHLCKE'[check % 23];
          return (check === v.substr(8, 1));
        }
        break;
      case 9:
        isValid = /^ES[0-9A-Z][0-9]{7}[0-9A-Z]$/.test(id);
        const cif = id.substr(2);
        if (!isValid) return false;

        const firstChar = cif.charAt(0);
        if ('KLM'.indexOf(firstChar) !== -1) {
          check = parseInt(cif.substr(1, 8), 10);
          check = 'TRWAGMYFPDXBNJZSQVHLCKE'[check % 23];
          return `${check}` === cif.substr(8, 1);
        } if ('ABCDEFGHJNPQRSUVW'.indexOf(firstChar) !== -1) {
          const weight = [2, 1, 2, 1, 2, 1, 2];
          let sum = 0;
          let temp = 0;
          for (let i = 0; i < 7; i++) {
            temp = parseInt(cif.charAt(i + 1), 10) * weight[i];
            if (temp > 9) {
              temp = Math.floor(temp / 10) + temp % 10;
            }
            sum += temp;
          }
          sum = 10 - sum % 10;
          if (sum === 10) {
            sum = 0;
          }
          return `${sum}` === cif.substr(8, 1) || 'JABCDEFGHI'[sum] === cif.substr(8, 1);
        }

        break;
      case 9:
        if (/^[a-z]{3}[0-9]{6}[a-z]?$/i.test(id)) return true;
        break;
      default:
        return false;
    }
  }

  if (country === 'PT') {
    switch (type) {
      case 1:
        if (/^[0-9]{7,8}\ [0-9]\ ([A-Z]|[0-9]){2}[0-9]$/.test(id)) return true;
        break;
      case 2:
        if (/^[0-9]{7,8}\ [0-9]$/.test(id)) return true;
        break;
      case 5:
        if (/^[a-z]{3}[0-9]{6}[a-z]?$/i.test(id)) return true;
        break;
      default:
        return false;
    }
  }

  if (country === 'COL') {
    const v = id.replace(/\./g, '').replace('-', '');
    if (!/^\d{8,16}$/.test(v)) {
      return false;
    }
    const { length } = v;
    const weight = [3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71];
    let sum = 0;
    for (let i = length - 2; i >= 0; i--) {
      sum += parseInt(v.charAt(i), 10) * weight[i];
    }
    sum %= 11;
    if (sum >= 2) {
      sum = 11 - sum;
    }
    return `${sum}` === v.substr(length - 1);
    // Pasaporte COl
    //   if(/^[a-z]{3}[0-9]{7}[a-z]?$/i.test(id)) return true;
    //   break;
  }

  if (country === 'MEX') {
    const v = id.toUpperCase();
    if (!/^[A-Z]{4}\d{6}[A-Z]{6}[0-9A-Z]\d$/.test(v)) {
      return false;
    }

    const blacklistNames = [
      'BACA', 'BAKA', 'BUEI', 'BUEY', 'CACA', 'CACO', 'CAGA', 'CAGO', 'CAKA', 'CAKO', 'COGE', 'COGI', 'COJA',
      'COJE', 'COJI', 'COJO', 'COLA', 'CULO', 'FALO', 'FETO', 'GETA', 'GUEI', 'GUEY', 'JETA', 'JOTO', 'KACA',
      'KACO', 'KAGA', 'KAGO', 'KAKA', 'KAKO', 'KOGE', 'KOGI', 'KOJA', 'KOJE', 'KOJI', 'KOJO', 'KOLA', 'KULO',
      'LILO', 'LOCA', 'LOCO', 'LOKA', 'LOKO', 'MAME', 'MAMO', 'MEAR', 'MEAS', 'MEON', 'MIAR', 'MION', 'MOCO',
      'MOKO', 'MULA', 'MULO', 'NACA', 'NACO', 'PEDA', 'PEDO', 'PENE', 'PIPI', 'PITO', 'POPO', 'PUTA', 'PUTO',
      'QULO', 'RATA', 'ROBA', 'ROBE', 'ROBO', 'RUIN', 'SENO', 'TETA', 'VACA', 'VAGA', 'VAGO', 'VAKA', 'VUEI',
      'VUEY', 'WUEI', 'WUEY',
    ];
    const name = v.substr(0, 4);
    if (blacklistNames.indexOf(name) >= 0) {
      return false;
    }

    const gender = v.charAt(10);
    if (gender !== 'H' && gender !== 'M') {
      return false;
    }

    const state = v.substr(11, 2);
    const states = [
      'AS', 'BC', 'BS', 'CC', 'CH', 'CL', 'CM', 'CS', 'DF', 'DG', 'GR', 'GT', 'HG', 'JC', 'MC', 'MN', 'MS',
      'NE', 'NL', 'NT', 'OC', 'PL', 'QR', 'QT', 'SL', 'SP', 'SR', 'TC', 'TL', 'TS', 'VZ', 'YN', 'ZS',
    ];
    if (states.indexOf(state) === -1) {
      return false;
    }

    const alphabet = '0123456789ABCDEFGHIJKLMN&OPQRSTUVWXYZ';
    let sum = 0;
    const { length } = v;
    for (let i = 0; i < length - 1; i++) {
      sum += (18 - i) * alphabet.indexOf(v.charAt(i));
    }
    sum = (10 - sum % 10) % 10;
    return `${sum}` === v.charAt(length - 1);

    // const reg = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
    // var isValid = id.match(reg);
    // if (!isValid) return false;
    // const digitoVerificador = isValid?.pop(),
    //       rfcSinDigito      = isValid?.slice(1).join(''),
    //       len               = rfcSinDigito?.length,
    //       diccionario       = "0123456789ABCDEFGHIJKLMN&OPQRSTUVWXYZ Ñ",
    //       indice            = len? + 1;
    // let suma, digitoEsperado;
    // if (len == 12) suma = 0
    // else suma = 481;

    // for(var i=0; i<len; i++)
    //     suma += diccionario.indexOf(rfcSinDigito.charAt(i)) * (indice - i);
    // digitoEsperado = 11 - suma % 11;
    // if (digitoEsperado == 11) digitoEsperado = 0;
    // else if (digitoEsperado == 10) digitoEsperado = "A";


    // TODO Falta pasaporte Mexicano
  }
  return true;
}
